/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each curve is a Gaussian kernel density estimate of its group's values, scaled so adjacent ridges overlap for a sense of depth.`)
};

const es_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada curva es una estimación de densidad de kernel gaussiano de los valores de su grupo, escalada para que las crestas adyacentes se superpongan y den sensación de profundidad.`)
};

const de_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Kurve ist eine Gauß-Kerndichteschätzung der Werte ihrer Gruppe, skaliert so, dass benachbarte Grate für ein Tiefengefühl überlappen.`)
};

const nl_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke curve is een Gaussiaanse kerndichtheidsschatting van de waarden van zijn groep, geschaald zodat aangrenzende richels overlappen voor een gevoel van diepte.`)
};

const fr_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque courbe est une estimation de densité par noyau gaussien des valeurs de son groupe, mise à l'échelle pour que les crêtes adjacentes se chevauchent afin de donner une impression de profondeur.`)
};

const it_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni curva è una stima di densità kernel gaussiana dei valori del suo gruppo, scalata in modo che i ridge adiacenti si sovrappongano per dare un senso di profondità.`)
};

const pt_br2_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada curva é uma estimativa de densidade de kernel gaussiano dos valores do seu grupo, escalada para que as cristas adjacentes se sobreponham, dando uma sensação de profundidade.`)
};

const pt_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada curva é uma estimativa de densidade por kernel gaussiano dos valores do respetivo grupo, escalada para que as cristas adjacentes se sobreponham, dando sensação de profundidade.`)
};

const ja_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各曲線は各グループの値のガウスカーネル密度推定であり、隣接するリッジが重なり合って奥行きを感じさせるようスケーリングされています。`)
};

const zh_ridge_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条曲线都是该组数值的高斯核密度估计，经过缩放使相邻山脊重叠以产生层次感。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_faq_a3", locale)
	if (locale === "en") return en_ridge_faq_a3(inputs)
	if (locale === "es") return es_ridge_faq_a3(inputs)
	if (locale === "de") return de_ridge_faq_a3(inputs)
	if (locale === "nl") return nl_ridge_faq_a3(inputs)
	if (locale === "fr") return fr_ridge_faq_a3(inputs)
	if (locale === "it") return it_ridge_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_faq_a3(inputs)
	if (locale === "pt") return pt_ridge_faq_a3(inputs)
	if (locale === "ja") return ja_ridge_faq_a3(inputs)
	return zh_ridge_faq_a3(inputs)
};